<div class="rating-container d-flex align-items-center">
  @if(showRating) {
  <span style="padding-right: 2px">
    {{ rating1to5rounded }}
  </span>
  } @if(isCompact) {
  <mat-icon style="width: 1em; height: 1em; font-size: 1em"> star </mat-icon>
  } @else { @for(item of [].constructor(numFullStars); track $index) {
  <mat-icon style="width: 1em; height: 1em; font-size: 1em"> star </mat-icon>
  } @if(showHalfStar) {
  <mat-icon style="width: 1em; height: 1em; font-size: 1em">
    star_half
  </mat-icon>
  } @if(showEmptyStars && numEmptyStars > 0) { @for(item of
  [].constructor(numEmptyStars); track $index) {
  <mat-icon style="width: 1em; height: 1em; font-size: 1em">
    star_border
  </mat-icon>
  } } @if(showNumReviews) {
  <span class="ps-1"> ({{ numReviews }}) </span>
  } }
</div>
